<template>
    <div class="pageContainer Menu">
        <el-row type="flex" style="margin-bottom: 15px" justify="start">
            <el-button size="small" icon="el-icon-plus" @click="formAdd" type="primary">新增</el-button>
        </el-row>
        <el-row type="flex" style="margin-bottom: 20px" justify="start">
            <el-tabs v-model="activeName" type="border-card" style="width: 100%">
                <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
                    
                    <el-table
                        :data="tableData"
                        style="width: 100%;margin-bottom: 20px;"
                        row-key="id"
                        border stripe
                        default-expand-all
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                        <el-table-column prop="dept_name" label="部门名称" min-width="180"></el-table-column>
                        <el-table-column prop="dept_code" label="部门代码" min-width="180"></el-table-column>
                        <el-table-column prop="sort" label="排序" min-width="180"></el-table-column>
                        <el-table-column
                            fixed="right" label="操作" min-width="200">
                            <template slot-scope="scope">
                                <el-popconfirm
                                    width="250"
                                    confirmButtonText='确定'
                                    cancelButtonText='取消'
                                    icon="el-icon-info"
                                    iconColor="red"
                                    @confirm="handleDel(scope.row)"
                                    placement="left"
                                    title="是否确定删除？">
                                    <a slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
                                </el-popconfirm>
                                <el-button @click="handleModify(scope.row)" type="text" size="small">修改</el-button>
                                <el-button @click="handleAdd(scope.row)" type="text" size="small">添加下级</el-button>
    
                                <el-dropdown :split-button="false" trigger="click" type="text"
                                             class="dropdown el-dropdown-link">
                                    <a style="font-size: 12px;margin-left: 10px;cursor: pointer">
                                        更多<i class="el-icon-caret-bottom el-icon--right"></i>
                                    </a>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="showUser(scope.row)"
                                                          style="font-size: 12px;color: #409eff;">关联用户</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-row>
        <el-dialog :title="modalTitle" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true">
            <el-form :model="formData" :rules="rules" ref="adminUserInfo" label-width="120px"
                     style="max-height: 450px;overflow-y: auto;min-height: 300px;">
                <el-form-item label="上级部门" prop="pid">
                    <el-cascader ref="firstCascader" :options="tableData"
                                 :disabled="modalTitle=='修改'"
                                 :props="defaultProps"
                                 v-model="formData.pid"
                                 :show-all-levels="false"
                                 @change="handleCascaderChange"
                                 placeholder="请选择"
                                 filterable style="width: 50%"></el-cascader>
                </el-form-item>
                
                <el-form-item label="部门名称" prop="dept_name">
                    <el-input v-model.trim="formData.dept_name" style="width: 50%" />
                </el-form-item>
                <el-form-item label="部门代码" prop="dept_code">
                    <el-input v-model.trim="formData.dept_code" style="width: 50%"/>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model.trim="formData.sort" style="width: 50%" />
                </el-form-item>
            </el-form>
            <el-row>
                <el-col :span="22" style="text-align: right;">
                    <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('adminUserInfo')">保存</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    
        <User ref="visiable_user"
                  :editOptions="editUser"
                  @saveUser="saveUser"></User>
    </div>
</template>
<script>
	import api from '@/api/api';
	import User from './components/User'
	export default {
		name: 'Menu',
		components: {
			User
		},
		data () {
			return {
				visible: false,
				isShowModal: false,
				modalTitle:'添加',
				formData: {},
				defaultProps: {
					label: 'dept_name',
					value: 'id',
					children: 'children',
					emitPath: false,
					checkStrictly: true },
				//table
				tabMapOptions: [
					{ label: '部门管理', key: 'CN' },
				],
				activeName: 'CN',
				tableData: [],
				rules: {
					dept_name:[
						{ required: true, message: '请输入部门名称', trigger: 'blur' },
					],
					dept_code:[
						{ required: true, message: '请输入部门代码', trigger: 'blur' },
					],
				},
				teacherList:[],
				editUser:{},
				deptId:null,
			}
		},
		watch: {
			'formData.pid'() {
				if (this.$refs.firstCascader) {
					this.$refs.firstCascader.dropDownVisible = false; //监听值发生变化就关闭它
				}
			},
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList(){
				let _this = this
				this.$http.post(api.tea_deptList).then(res => {
					if (res.data && res.data.length > 0) {
						_this.deleteEmptyGroup(res.data).then(result => {
							_this.tableData = result
						})
					} else {
						this.$message.error(res.msg)
					}

				})
			},
			// 处理没有children的分组
			deleteEmptyGroup (treeData) {
				return new Promise(resolve => {
					function traversal (data) {
						data.map(item => {
							for (let info in item) {
								if (item['children']) {
									if (item['children'].length > 0) {
										traversal(item['children'])
									}
									if (item['children'].length == 0) {
										delete item['children']
									}
								}
							}
						})
					}

					traversal(treeData)
					resolve(treeData)
				})
			},

			formAdd(){
				this.isShowModal = true;
				this.formData = {}
				this.formData = {
					pid: 0,
				}
				this.formData.node_type = 'dept'
				this.modalTitle = '添加'
			},
			handleAdd(row){
				this.isShowModal = true;
				this.formData = {}
				this.formData = {
					pid:row.id,
				}
				if(row.node_type == 'dept'){
					this.formData.node_type = 'major'
				}else if(row.node_type == 'major'){
					this.formData.node_type = 'class'
				}
				this.modalTitle = '添加'
			},
			handleModify(row){
				this.isShowModal = true;
				this.modalTitle = '修改';
				this.formData = row
			},
			handleDel(row){
				this.$http.post(api.tea_deptDel,{id:String(row.id)}).then(res=>{
					this.$message.success('删除成功')
					this.getList();
				})
			},
			handleCascaderChange(e){
				console.log(1,e)
			},

			submitForm (formName) {
				let _this = this
				_this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$http.post(api.tea_deptSave,this.formData).then(res => {
							this.$message.success('保存成功')
							this.getList();
							this.isShowModal = false;
						})
					}
				})
			},
			showUser(row){
				let _this = this
				_this.deptId = row.id
				_this.editUser = row
				_this.$refs.visiable_user.show()
			},
			saveUser(e){
				this.$http.post(api.deptUserSave,{
					dept_id: this.deptId,
					teacher_id:e
                }).then(res => {
					this.$message.success('保存成功')
					this.getList();
					this.$refs.visiable_user.handleCancel()
				})
			},
		}
	}
</script>
